import React, { useReducer } from "react";
import { alertSimpleReducer, defaultState, initialize, validateForm } from "./reducer";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Input,
  Button,
  Label,
} from "reactstrap";
import style from "./AlertSimple.module.scss";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import classnames from "classnames";
import Account from "./Fields/Account";
import Process from "./Fields/Process";
import { Field, Combobox } from "../Order/Field/Field";
import { PersonType, getPersonTypeName } from "./Fields/types";

const AlertSimple = ({ open, toggle, fetchs, ...props }) => {
  const [state, dispatch] = useReducer(alertSimpleReducer, defaultState(), initialize(props));
  const { alert, buttons } = state;
  const { readonly, errors } = state.fields;

  const confirm = () => {
    const errors = validateForm(state);

    if (errors == false) {
      dispatch({ type: "UPDATE_BUTTONS", buttons: { confirm: { loading: true } } });

      const { id, ...alertProps } = alert;

      fetchs.updateAlert(
        {
          eventIN: {
            ...alertProps,
            accountId: alertProps.personType == PersonType.All ? id : null,
            personId: alertProps.personType != PersonType.All ? id : null,
          },
        },
        (response) => {
          toggle({
            ...alertProps,
            accountId: alertProps.personType == PersonType.All ? id : null,
            personId: alertProps.personType != PersonType.All ? id : null,
            id: response.eventId,
          });
        }
      );
    } else {
      dispatch({ type: "FORCE_UPDATE_VALIDATION", errors });
    }
  };

  const onChange = (fields) => dispatch({ type: "CHANGE_FIELDS", fields });

  const globalReadOnly = buttons.confirm.loading;

  return (
    <Modal isOpen={open} className={style.modal}>
      <ModalHeader toggle={toggle}>New Alert</ModalHeader>
      <ModalBody className={style.body}>
        <Container>
          <Row>
            <Col lg={6} xs={12}>
              <Process
                onChange={(values) => onChange(values)}
                error={errors.processes}
                disabled={readonly.processes || globalReadOnly}
                value={alert.processes}
                fetchProcesses={fetchs.processes}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6} xs={12}>
              <Field label={"Type"} error={errors.personType}>
                <Combobox
                  style={{ background: "#edf9ff", fontWeight: 500 }}
                  value={alert.personType}
                  disabled={readonly.personType || globalReadOnly}
                  onChange={(v) => onChange({ personType: v })}
                  items={Object.values(PersonType).map((key, index) => ({
                    id: key,
                    description: getPersonTypeName(key),
                  }))}
                />
              </Field>
            </Col>

            <Col lg={6} xs={12}>
              <Account
                onChange={(values) => onChange(values)}
                error={errors.name}
                disabled={globalReadOnly}
                value={alert.name}
                type={alert.personType}
                fetchs={{
                  accounts: fetchs.accounts,
                  persons: fetchs.persons,
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Field label={"Title"} error={errors.title}>
                <Input
                  type={"text"}
                  placeholder={"Title"}
                  value={alert.title || ""}
                  disabled={readonly.title || globalReadOnly}
                  invalid={!!errors.title}
                  onChange={(e) => onChange({ title: e.target.value })}
                />
              </Field>

              <Field label={"Data related"} error={errors.trigger}>
                <Input
                  type={"text"}
                  placeholder={"Data Related"}
                  value={alert.trigger || ""}
                  disabled={readonly.trigger || globalReadOnly}
                  invalid={!!errors.trigger}
                  onChange={(e) => onChange({ trigger: e.target.value })}
                />
              </Field>

              <Field label={"Description"} error={errors.description}>
                <Input
                  type={"textarea"}
                  rows={2}
                  placeholder={"Description"}
                  value={alert.description || ""}
                  disabled={readonly.description || globalReadOnly}
                  invalid={!!errors.description}
                  onChange={(e) => onChange({ description: e.target.value })}
                />
              </Field>
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={() => toggle()}>
          Close
        </Button>
        <LaddaButton
          className={classnames("btn btn-ladda btn-primary")}
          loading={buttons.confirm.loading}
          onClick={() => confirm()}
          data-style={EXPAND_RIGHT}
        >
          {"Create"}
        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
};

export function validations(alert) {
  return {
    name: { empty: alert.personType == PersonType.All },
    title: { empty: true },
    trigger: { empty: true },
    description: { empty: true },
    processes: { empty: true },
  };
}

export default AlertSimple;
